export default "__VITE_ASSET__0bRQOchf__"